import React from 'react';
import ReactDOM from 'react-dom';
// import { init } from '@sentry/react';

import createHistory from 'history/createBrowserHistory';
import './styles/index.scss';
import Router from './Router';

// init({
//     dsn: 'https://9dd6548f721e41cc8fc470addf4250fe@o1261391.ingest.us.sentry.io/4504882623545344',
//     integrations: []
// });

const history = createHistory();
ReactDOM.render(<Router history={ history }/>, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.jsx